module.exports = __webpack_public_path__ + "img/tournament-2021.57ed9b59.png";